import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'packages',
            name: 'package',
            class: 'Modules\\Package\\Entities\\Package',

            formatted: {
                tangible: 'Tangible (Producto físico)',
                intangible: 'Intangible (Servicio)'
            },

            types: [
                'tangible',
                'intangible'
            ]
        }
    },

    methods: {
        getNew() {
            return {
                type: 'tangible',
                weight: 1,
                height: 1,
                width: 1,
                length: 1
            }
        }
    }
}